import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Link, useNavigate } from 'react-router';
import { formatDate } from '@/lib/utils';

export interface RecordCardProps {
  record: {
    id: string;
    englishName: string | null;
    scientificName: string | null;
    orgName: string | null;
    orgId: string | null;
    dtm: string;
    note: string | null;
    locationNote: string | null;
  };
  onClick?: () => void;
}

export const RecordCard: React.FC<RecordCardProps> = ({ record, onClick }) => {
  const navigate = useNavigate();

  return (
    <div
      className="rounded-lg shadow bg-white/90 p-4 flex flex-col gap-2 cursor-pointer"
      onClick={onClick ?? (() => navigate(`/app/record/${record.id}`))}
      data-testid={`record-card-${record.id}`}
    >
      <div>
        <div className="font-medium text-lg">{record.englishName || 'Unknown Species'}</div>
        <div className="text-sm italic text-muted-foreground">{record.scientificName}</div>
      </div>
      <div>
        {record.orgId ? (
          <Link to={`/app/org/${record.orgId}`} onClick={e => e.stopPropagation()}>
            <Badge className="cursor-pointer">{record.orgName || 'Unknown'}</Badge>
          </Link>
        ) : (
          <Badge>{record.orgName || 'Unknown'}</Badge>
        )}
      </div>
      <div>
        <p className="text-sm text-muted-foreground">{record.note || '-'}</p>
        {record.locationNote && (
          <p className="text-sm text-muted-foreground mt-1">{record.locationNote}</p>
        )}
      </div>
      <div className="text-xs text-muted-foreground mt-2">{formatDate(record.dtm)}</div>
    </div>
  );
};
